import React from 'react'
import * as R from 'ramda'
import { Box } from 'components/layout/Box/Box'
import { SecondaryTabsBar } from 'components/shared/SecondaryTabsBar/SecondaryTabsBar'
import { Trait } from '../Trait/Trait'
import { personalityOverviewTab } from '../../model'
import styles from './PersonalityFactors.module.scss'
import { PersonalityOverview } from './PersonalityOverview/PersonalityOverview'

export const PersonalityFactors = ({
  language,
  factors,
  scores,
  personalityTab,
  setPersonalityTab,
  selectedCandidates,
  setSelectedCandidates,
  response,
  candidates,
  name,
}) => {
  const tabConfig = R.find(R.propEq('id', personalityTab), factors)
  const factor = R.prop('factor', tabConfig)
  const overviewTab = personalityOverviewTab()
  const single = candidates.length === 1

  return (
    <Box align="center" direction="column" className={styles.personailty}>
      <SecondaryTabsBar
        tabs={[
          overviewTab,
          ...R.map(({ label, id }) => ({ id, label }), factors),
        ]}
        activeTab={personalityTab}
        setActiveTab={setPersonalityTab}
      />
      {personalityTab === overviewTab.id ? (
        <PersonalityOverview
          {...{
            factors,
            language,
            single,
            response,
            scores,
            candidates,
            selectedCandidates,
            setSelectedCandidates,
            setPersonalityTab,
            name,
          }}
        />
      ) : (
        <Trait
          minimize
          key={factor}
          groups={tabConfig?.groups}
          {...{
            factor,
            language,
            scores,
            name,
            single,
            response,
            selectedCandidates,
            setSelectedCandidates,
            candidates,
          }}
        />
      )}
    </Box>
  )
}
